<template>
  <div>
    <back-btn />

    <v-row justify="center">
      <v-col cols="12" md="6">
        <admin-form @emitAdminData="createAdmin" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AdminForm from "@/components/admin/AdminForm";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    AdminForm,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    createAdmin(payload) {
      console.log(payload);
      this.$store.dispatch("Admin/createAdmin", payload).then(() => {
        this.$router.push("/admins");
      });
    },
  },
};
</script>
